import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { FormSectionContent } from '@modules/requirement/requirement-form/form-section-content.component'
import { FormSection } from '@modules/requirement/requirement-form/form-section.component'
import {
  AuditRequirementResponse,
  RequirementPageType,
  Roles,
} from '@shared/types'
import { format } from 'date-fns'
import { FormLegalBasis } from './form-legal-basis.component'
import { FormRequirementForms } from './form-requirement-forms'
import { useACL } from '@shared/hooks/use-acl.hook'

interface Props {
  requirement: AuditRequirementResponse
  type: RequirementPageType
}

export const RequirementDetails = ({ requirement, type }: Props) => {
  const { is } = useACL()
  const isClienBasic = is([Roles.ClientBasic])
  const completedDateFormatted =
    requirement.isDraft || !requirement.fixDate
      ? 'Nie oceniono'
      : format(new Date(requirement.evaluationDate ?? new Date()), 'dd/MM/yyyy')

  return (
    <>
      {requirement && (
        <FormSection title="Podstawy prawne">
          <FormLegalBasis requirement={requirement} />
        </FormSection>
      )}
      {requirement.forms?.length! > 0 && (
        <FormSection title="Formularze">
          <FormRequirementForms forms={requirement.forms ?? []} />
        </FormSection>
      )}
      {['admin', 'assessment', 'published'].includes(type) &&
        !isClienBasic &&
        completedDateFormatted && (
          <FormSection title="Data oceny">
            <FormSectionContent content={completedDateFormatted} />
          </FormSection>
        )}
      {requirement.description && (
        <FormSection title="Wymagania prawne">
          <FormSectionContent content={requirement.description} />
        </FormSection>
      )}
      {requirement.tooltipData && (
        <FormSection title="Objaśnienia">
          <FormSectionContent content={requirement.tooltipData} />
        </FormSection>
      )}
    </>
  )
}

export const useStyles = makeStyles((theme) => {
  return {}
})
